(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-info-box.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-info-box.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactPaper: Paper
} = svs.ui;
const RetailerInfoBox = _ref => {
  let {
    icon,
    text
  } = _ref;
  return React.createElement(Paper, {
    branding: "sport",
    className: "co-op-play-container co-op-play-no-result-holder"
  }, React.createElement("div", {
    className: "co-op-play-no-result"
  }, React.createElement(Icon, {
    icon: icon,
    size: "800"
  }), React.createElement("span", {
    className: "h3"
  }, text)));
};
RetailerInfoBox.defaultProps = {
  icon: 'search',
  text: 'Din sökning gav tyvärr inga resultat'
};
setGlobal('svs.components.tipsen.RetailerInfoBox', RetailerInfoBox);

 })(window);